import React from 'react'
import { Button } from 'reactstrap'
import PropTypes from 'prop-types'

const propTypes = {
  voucherGenerateFlag        : PropTypes.bool,
  handleClickGenerateVoucher : PropTypes.func
}

const defaultProps = {
  voucherGenerateFlag        : true,
  handleClickGenerateVoucher : () => {}
}

const GenerateVoucherButton = ({
  voucherGenerateFlag,
  handleClickGenerateVoucher
}) => {
  if (!voucherGenerateFlag) return (
    <Button
      className='mt-4'
      color='success'
      onClick={ handleClickGenerateVoucher }
    >
      Generate Voucher
    </Button>
  )
  return null
}

GenerateVoucherButton.propTypes    = propTypes
GenerateVoucherButton.defaultProps = defaultProps

export default GenerateVoucherButton
